export const RedemptionStatusNames = {
    Pending: 'pending',
    Reconciled: 'reconciled',
};
export const ReceiptStatusNames = {
    ...RedemptionStatusNames,
    Withdrawn: 'withdrawn',
};
//# sourceMappingURL=receipt.js.map